// A separate object for the infoBox data is used due to the typing of the borderColour attribute
import type { InfoBoxProps } from '../../../../../shared/types/toolTypes'

export const infoBox: InfoBoxProps = {
  heading: 'What could this include?',
  borderColour: 'blue',
}

export const hasExpensesData = {
  hasExpensesButtons: [
    {
      label: 'Yes',
      id: 'yes',
    },
    {
      label: 'No',
      id: 'no',
    },
  ],
  title: 'Are you claiming for out-of-pocket expenses?',
  image: {
    src: 'https://media.product.which.co.uk/prod/images/original/35a9c0e3cc29-tooliconmoney.jpg',
    alt: '',
  },
  infoBox,
  infoBoxParagraphs: [
    {
      text: 'For example, if the food that was part of an all-inclusive deal was inedible, you could claim the reasonable cost of buying food elsewhere',
    },
  ],
}
